import { render, staticRenderFns } from "./ReportByQuestion.vue?vue&type=template&id=31d7de12"
import script from "./ReportByQuestion.vue?vue&type=script&lang=ts"
export * from "./ReportByQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports